module.exports = __webpack_public_path__ + "static/media/sales.52b3b86c.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/sales.png
// module id = 501
// module chunks = 0